/* -------------------------------------------------------------------------- */
/*                     Adds class to minicart when clicked                    */
/* -------------------------------------------------------------------------- */
document.addEventListener("DOMContentLoaded", function () {
  // Get the element with class "mini-cart-btn"
  const miniCartBtn = document.querySelector(".mini-cart-btn");
  const cart = document.querySelector(".site-nav__cart");
  if (!miniCartBtn) return;
  if (!cart) return;

  // Add a click event listener to the element
  miniCartBtn.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent default behavior

    // Toggle the class "mini-cart-btn__active"
    this.classList.toggle("mini-cart-btn__active");

    // Toggle the class "site-nav__cart__active"
    cart.classList.toggle("site-nav__cart__active");
  });

  // // Get the element with class "mini-cart-btn mobile"
  // const miniCartBtnMobile = document.querySelector(".mini-cart-btn-mobile");
  // const cartMobile = document.querySelector(".site-nav__cart-mobile");

  // if (!cartMobile) return;
  // if (!miniCartBtnMobile) return;
  // // Add a click event listener to the element
  // miniCartBtnMobile.addEventListener("click", function (event) {
  //   event.preventDefault(); // Prevent default behavior

  //   // Toggle the class "mini-cart-btn__active"
  //   this.classList.toggle("mini-cart-btn-mobile__active");

  //   // Toggle the class "site-nav__cart__active"
  //   cartMobile.classList.toggle("site-nav__cart-mobile__active");
  // });
});
